<footer [ngStyle]="{height}" class="footer background-dark">
  <div class="terms-container">
    <a class="text-light pointer" (click)="showLegalPolicies()">Privacy Policy</a>
    <a class="text-light pointer" (click)="showTermsOfService()">Terms and Conditions</a>
  </div>
  <p class="text-light questions-text">For questions or general support please contact support@telemated.com</p>
  <div></div>
</footer>
